/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Updated_FromInputs */



/**
* | output |
* | --- |
* | "Updated from" |
*
* @param {Explorer_Search_Updated_FromInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_updated_from = /** @type {((inputs?: Explorer_Search_Updated_FromInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Updated_FromInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Updated from")
	if (locale === "de") return /** @type {LocalizedString} */ ("Updated from")
	if (locale === "it") return /** @type {LocalizedString} */ ("Updated from")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Updated from")
	if (locale === "es") return /** @type {LocalizedString} */ ("Updated from")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Updated from")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Updated from")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Updated from")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Updated from")
	return /** @type {LocalizedString} */ ("Updated from")
});